import {
  WmTabItem,
  WmTabList,
  WmTabPanel
} from "@watermarkinsights/ripple-react";
import { useReducer } from "react";
import { useIntl } from "react-intl";
import WidgetLoader from "@/features/common/elements/WidgetLoader";

import translate from "@/i18n/translate";
import "../Lightcast.scss";
import PopulationByAge from "./PopulationByAge";
import PopulationByRaceEthnicity from "./PopulationByRaceEthnicity";
import { Tab } from "../Interface";

type Tabs = {
  ageCohort: boolean;
  raceEthinicity: boolean;
};

interface ChangeInPopulationState {
  selectedTab: string;
  loadedTabs: Tabs;
}

interface ChangeInPopulationAction {
  type: string;
  tabId: string;
  tab: string;
}

const defaultChangeInPopulationAction = {
  type: "",
  tabId: "",
  tab: ""
};

const reducer = (
  state: ChangeInPopulationState,
  action: ChangeInPopulationAction
) => {
  switch (action.type) {
    case "SetSelectedTab":
      return { ...state, selectedTab: action.tabId };
    case "setLoadedTab":
      const tab = action.tab;
      let loadedTabs = state.loadedTabs;
      loadedTabs[tab] = true;
      return { ...state, loadedTabs: loadedTabs };
    default:
      return state;
  }
};

const allTabsLoaded = (loadedTabs: Tabs) => {
  return loadedTabs.ageCohort && loadedTabs.raceEthinicity;
};

export interface ChangeInPopulationProps {
  onComponentLoad: (component: string) => void;
}

export default function ChangeInPopulation({
  onComponentLoad
}: ChangeInPopulationProps) {
  function setTooglePosition(event: any, chartId: string) {
    var chartBodyRect: any;
    chartBodyRect = document
      .querySelector("." + chartId)
      ?.getBoundingClientRect();
    const targetRect = event.target.getBoundingClientRect();
    const availableSpaceLeft = targetRect.left - chartBodyRect?.left;
    const availableSpaceRight = chartBodyRect?.right - targetRect.right;
    if (window.innerWidth >= 1024) {
      event.target.childNodes[0].style.width = "180px";
    } else {
      event.target.childNodes[0].style.width = "160px";
    }

    if (availableSpaceLeft > availableSpaceRight) {
      event.target.childNodes[0].style.right = "30%";
      event.target.childNodes[0].style.removeProperty("left");
    } else {
      event.target.childNodes[0].style.left = "10%";
      event.target.childNodes[0].style.removeProperty("right");
    }
  }
  const ageCohortLabel = useIntl().formatMessage({
    id: "app.changeInPopulation.ageCohortLabel"
  });

  const raceEthnicityLabel = useIntl().formatMessage({
    id: "app.changeInPopulation.raceEthnicityLabel"
  });

  const tabOption = [
    {
      name: ageCohortLabel,
      id: "age-cohort"
    },
    {
      name: raceEthnicityLabel,
      id: "race-ethnicity"
    }
  ];

  const initialState = {
    selectedTab: "change-in-population-tab-1",
    loadedTabs: {
      ageCohort: false,
      raceEthinicity: false
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const onWmTabSelected = (event: CustomEvent) => {
    dispatch({
      ...defaultChangeInPopulationAction,
      type: "SetSelectedTab",
      tabId: event.detail.tabId
    });
  };

  const onTabLoad = (tab: string) => {
    dispatch({
      ...defaultChangeInPopulationAction,
      type: "setLoadedTab",
      tab: tab
    });
  };
  return (
    <div className="paper-card">
      <div className="header">
        <div className="info" id="change-population-info">
          <h3 className="title">
            {translate("app.changeInPopulation.changePopulationLabel")}
          </h3>
          <div className="description -descrip">
            {translate("app.changeInPopulation.helperText")}
          </div>
        </div>
      </div>
      <div className="body" id="population-change-tab-component">
        {!allTabsLoaded(state.loadedTabs) && (
          <WidgetLoader
            loaderContainerClasses="loader"
            loaderClasses="content"
          />
        )}
        {allTabsLoaded(state.loadedTabs) && (
          <div className="tabbar">
            <WmTabList
              id="tab-with-controller-change-in-population"
              selectedTab={state.selectedTab}
              onWmTabSelected={onWmTabSelected}
            >
              {tabOption.map((tab: Tab, index: number) => (
                <WmTabItem
                  tabId={"change-in-population-tab-" + (index + 1)}
                  key={tab.id + (index + 1)}
                >
                  {tab.name}
                </WmTabItem>
              ))}
            </WmTabList>
          </div>
        )}
        <WmTabPanel
          className="tab-panel"
          id="tabs-one"
          tabId={"change-in-population-tab-1"}
        >
          <PopulationByAge
            setTooglePosition={setTooglePosition}
            onTabLoad={onTabLoad}
            onComponentLoad={onComponentLoad}
            showIntegratedHeader={true}
          ></PopulationByAge>
        </WmTabPanel>
        <WmTabPanel
          className="tab-panel"
          id="tabs-two"
          tabId={"change-in-population-tab-2"}
        >
          <PopulationByRaceEthnicity
            setTooglePosition={setTooglePosition}
            onTabLoad={onTabLoad}
            onComponentLoad={onComponentLoad}
            showIntegratedHeader={true}
          ></PopulationByRaceEthnicity>
        </WmTabPanel>
      </div>
    </div>
  );
}
